import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

import Dropzone from 'react-dropzone-uploader'

import TablaGalerias from './../components/TablaGalerias';
import TablaGaleriaImagen from '../components/TablaGaleriaImagen';
import Botonera from './../components/BotoneraGuardar';

import Galeria from './../api/Galeria'; 
const galeria = new Galeria(); 

class GestorGaleria extends Component {
    _isMounted = false;

    constructor() {
        super(); 
        this.state = {
            data : [],
            files: [],
            prefiles: [],
            nombre:'',
            ultima:'',
            id:'',
            cargando:true,
            validacion:{
                nombre:false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            confirmarBorrarImg: false,
            idBorrar:'',
            imagenBorrar:''
        }
    }

   
    

    estadoDefault = async () =>{

        await this.limpiar();

        this.setState({
           // files: [],
            prefiles: [],
            nombre:'',
            ultima:'',
            id:'',
            cargando:false,
            validacion:{
                nombre:false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            confirmarBorrarImg: false,
            idBorrar:'',
            imagenBorrar:''
        })

    }

    
    manejaNombre = evento => {
        this.setState({nombre: evento.target.value});
    }
    manejaDescripcion = evento => {
        this.setState({descripcion: evento.target.value});
    }


    /* funciones comunes para mensajes y validaciones */ 
    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListado();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            console.log(resultado);
            
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        let {nombre, files} = this.state;

        let vNombre   = validarItem({valor:nombre, input:'Nombre', vacio:true, largo:150});
        let vFiles   = validarItem({valor:files, input:'Imagenes', archivo:false});

        this.setState({ validacion:{
            nombre:    !vNombre.resultado,
            files:     !vFiles.resultado
        } });  
        
        let formulario = validarFormulario([vNombre, vFiles]); 

        return formulario;

    }

    /* ingresar */

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarGaleria = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarGaleriaBD = async () =>{
        this.setState({cargando:true});

        let {nombre, files} = this.state;
        let resultado = await galeria.ingresar(nombre, files);
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Galería ingresada correctamente'})
        //files.forEach(f => f.remove()); 
        await this.limpiar();
        this.estadoDefault();
        await this.cargarListado();
    }
    



    limpiar =  async () => {
        let files = this.state.files;
        files.forEach(f => f.remove());
    }

    /* editar */

    muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }

    editarGaleria = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    editarGaleriaBD = async () =>{
        this.setState({cargando:true});

        let {id, nombre, files} = this.state;
        let resultado = await galeria.editar(id, nombre, files);
        await galeria.editarBlog(id);
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Galería editada correctamente'})
        files.forEach(f => f.remove()); 
        this.estadoDefault();
        await this.cargarListado();
    }

    cargarEditar = async (c) => {
        this.setState({cargando:true});
        let resultado = await galeria.imagenes(c.id);
        let files = [];
        resultado.forEach(element => {
            files.push(element);
        });
        this.setState({id: c.id, nombre: c.nombre, prefiles: files, cargando:false}); 
    }

    cancelarEditar = () => {
        console.log('cancelar editar');
        
        let files = this.state.files;
        files.forEach(f => f.remove())
        this.setState({ nombre:'', files: [], prefiles: [], id:''}); 
    }
    

    /* borrar galeria */
    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }


    eliminarGaleria = async () => {
        this.setState({cargando:true});
        const {idBorrar} = this.state;
        let blogs = await galeria.getBlogs(idBorrar)
        let resultado = await galeria.eliminar(idBorrar)
        console.log(idBorrar);
        

        if(resultado==="ok"){
            await this.cargarListado();
            await galeria.eliminarEnBlog(blogs)
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Galería eliminada satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }


    /* borrar imagen */ 

    muestraConfirmarBorrarImg = (imagen) => {
        this.setState((prevState) => ({
            confirmarBorrarImg: !prevState.confirmarBorrarImg,
            imagenBorrar: imagen
        }));   
        
    }

    eliminarImagen = async () => {

        this.setState({cargando:true});
    
        let resultado = await galeria.eliminarImagen(this.state.imagenBorrar)

        if(resultado==="ok"){
            await galeria.editarBlog(this.state.id);
            let resultado = await galeria.imagenes(this.state.id);
            let files = [];
            resultado.forEach(element => {
                files.push(element);
            });
            this.setState({prefiles: files}); 
        
            await this.cargarListado();

           this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Imagen eliminada de la galería satisfactoriamente',
                level: 'info',
                position:'tr'
            });  
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});

    }


  
    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status, files) => { 
        if(status==='done'){
            this.setState({files: files});
        }
    }
  
    // receives array of files that are done uploading when submit button is clicked
    handleSubmit = (files) => { console.log(files.map(f => f.meta)) }

    cargarListado = async () => {
        let resultado = await galeria.mostrar(); 
        this.setState({data: resultado, cargando:false}); 
    }


    componentDidMount () {
        this.cargarListado();   
    }

    render(){
        const {data, nombre, id, prefiles, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, confirmarBorrarImg, validacion} = this.state;
        return (
            <Page title="Administrador de galeria" breadcrumbs={[ { name: 'Galerias', active: true } ]}>
                <Cargando valor={cargando}/>
                <Card>
                    <CardHeader>Información Galería</CardHeader>
                    <CardBody>
                    <Form>
                        <Row className="no-margin-bottom">
                            <Col  xl={3} lg={3} md={6} sm={12}>
                                <FormGroup>
                                    <Label>Nombre</Label>
                                    <Input
                                        type="text"
                                        placeholder=""
                                        onChange={this.manejaNombre}
                                        value={nombre}
                                        invalid={validacion.nombre}
                                        maxLength={150}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  sm={12}>
                                <TablaGaleriaImagen
                                data = {prefiles}
                                eliminar = {this.muestraConfirmarBorrarImg}
                                />
                            </Col>
                            <Col  sm={12}>
                                <Dropzone
                                    onChangeStatus={this.handleChangeStatus}
                                    accept="image/*"
                                    multiple
                                    submitButtonContent="Subir"
                                    inputWithFilesContent="Agregar"
                                    autoUpload="false"
                                    inputContent={(files, extra) => (extra.reject ? 'Solo archivos de imagen' : 'Click o arrastrar y soltar archivos')}
                                />
                            </Col>                    
                        </Row>    
                    </Form>
                    </CardBody>
                    <Botonera 
                        valor={id}
                        ingresar={this.ingresarGaleria}
                        editar={this.editarGaleria}
                        cancelar={this.cancelarEditar}
                    />
                </Card>
                <br/>
                <TablaGalerias
                    data = {data}
                    eliminar = {this.muestraConfirmarBorrar}
                    editar = {this.cargarEditar}
                    asociar = {null}
                    modo = {"galeria"}
                />


                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar la galería?"} 
                    funcion={this.ingresarGaleriaBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar la galería?"} 
                    funcion={this.editarGaleriaBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar la galería?"} 
                    funcion={this.eliminarGaleria} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrarImg} 
                    toggle={this.muestraConfirmarBorrarImg} 
                    texto={"¿Esta seguro de borrar la imagen de la galería?"} 
                    funcion={this.eliminarImagen} 
                />


                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        

            </Page>
        );

    }
};

export default GestorGaleria;
